import { createFileRoute } from '@tanstack/react-router';
import html from '#src/markdown/terms.en.md';
import { MarkdownPage } from '#src/pages/MarkdownPage/index.ts';

export const Route = createFileRoute('/{-$locale}/terms')({
  component: RouteComponent,
  ssr: true
});

function RouteComponent() {
  return <MarkdownPage html={html} />;
}
